import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ReviewPeriodCustomGoal } from 'src/app/models/review-period-custom-goal.model';
import { LanguageService } from 'src/app/services/language.service';
import { ErrorMessageService } from 'src/app/shared/services';

@Component({
  selector: 'app-review-period-custom-goal-dialog',
  templateUrl: './review-period-custom-goal-dialog.component.html',
  styleUrl: './review-period-custom-goal-dialog.component.scss'
})
export class ReviewPeriodCustomGoalDialogComponent {
  public mainForm: UntypedFormGroup;

constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ReviewPeriodCustomGoalDialogComponent>,
    private msgService: ErrorMessageService,
    private languageService: LanguageService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: ReviewPeriodCustomGoal
  ) {
     
  }

  ngOnInit(): void {
    this.mainForm = this.createForm();

    if (this.data) {
      this.mainForm.patchValue(this.data);
    }
  }

  createForm(): UntypedFormGroup {
    return this.fb.group({
      id: 0,
      reviewPeriodId: 0,
      nameHu: [null, Validators.required],
      nameEn: [null, Validators.required],
      isAllowChangeForLeader: [true],
      isAllowChangeForSelf: [true],
      isAllowChangeForAssistant: [false],
    });
  }

  public ok () {
    if (this.mainForm.invalid) return;

    let formData = this.mainForm.value as ReviewPeriodCustomGoal;

    formData.nameHu = formData.nameHu.trim();
    formData.nameEn = formData.nameEn.trim();

    const lang = this.languageService.getCurrentLanguage();
    formData.name = lang === 'hu' ? formData.nameHu : formData.nameEn;
    formData.name = lang === 'hu' ? formData.nameHu : formData.nameEn;

    this.dialogRef.close(formData);
  }
}
